import * as Contants from './mutationType'
import { Dialog, Toast} from 'vant'
import router from '../router/index'
import { getRequest} from '../utils/public'
import { post, get} from '../utils/request'
import { encryption} from '../utils/public'
import { requestMsg,requestInfo,userAccount} from '@/api/getData'
import { LOGIN_BASEURL } from '@/utils/utils'

export default {
  showloader: ({
    commit
  }) => {
    commit(Contants.SHOWLOADING)
  },
  hideloader: ({
    commit
  }) => {
    commit(Contants.HIDELOADING)
  },
  hasInfo({
    dispatch,
    commit,
    state
  },tologin = true) {
    return new Promise((resolve, reject) => {
      // let openid = state.userInfo.openid || localStorage.getItem('Openid')
      let snowflakeId = state.userInfo.snowflakeId || localStorage.getItem('SnowflakeId')
      // if (openid !== null && openid !== '' && openid !== undefined) {
        if (snowflakeId !== null) {
          new Promise((resolve, reject) => {
            post(`/user-auth-server/api/user/auth/verify`, {
              uid: snowflakeId
            }).then(res => {
              if (res.data.success) {
                resolve(res.data);
              }else{
                reject('nologin')
                if(tologin) {
                  dispatch('toLogin')
                }
              }
            }).catch(err => {
              reject('nologin')
              console.log(err)
            })
          }).then(res => {
            resolve()
          })
        } else {
          reject('nologin')
          if(tologin) {
            dispatch('toLogin')
          }
        }
      // } else {
      //   reject('nologin')
      //   if(tologin) {
      //     dispatch('toLogin')
      //   }
      // }
    })
  },
  hasInfoNoLogin({
    dispatch,
    commit,
    state
  }) {
    return new Promise((resolve, reject) => {
      let openid = state.userInfo.openid || localStorage.getItem('Openid')
      let snowflakeId = state.userInfo.snowflakeId || localStorage.getItem('SnowflakeId')
      // if (openid !== null && openid !== '' && openid !== undefined) {
        if (snowflakeId !== null) {
          new Promise((resolve, reject) => {
            post(`/user-auth-server/api/user/auth/verify`, {
              uid: snowflakeId
            }).then(res => {
              if (res.data.success) {
                resolve(res.data);
              }else{
                localStorage.clear()
              }
            }).catch(err => {
              console.log(err)
            })
          }).then(res => {
            resolve()
          })
        } else {
          // resolve()
        }
      // } else {
      //   // resolve()
      // }
    })
  },
  storeInfo({
    commit
  }) {
    let url = window.location.href;
    let arg = getRequest(url);
    if (arg.snowflakeId !== undefined && arg.accessToken !== undefined) {
      if (arg.openid != undefined && arg.openid != '') {
        commit('userOption', arg)
      } else {
        commit('userOption', arg)
        // Dialog.alert({
        //   message: '请在微信进行登录！',
        //   confirmButtonColor:'#378BE7'
        // }).then(() => {
        //   // on close
        // });
      }
    }
  },
  toLogin({
    state
  }) {
    Dialog.confirm({
      message: '您还未登录，请先登录',
      confirmButtonColor:'#378BE7'
    }).then(() => {
      let url = window.location.href
      window.location.href = LOGIN_BASEURL +`/login?from=${encryption(url)}&scope=snsapi_userinfo`
    }).catch(() => {
      // on cancel
    })
  },
  // 获取用户账号余额
  userAccount({ commit,state },params) {
    let trainingConfigId = state.homeID || localStorage.getItem('homeID')
    return userAccount({trainingConfigId:trainingConfigId}).then(res => {
      let data = res.data
      if (data.success) {
        commit('updateAccountInfo',data.data)
      }
      return data.data
    })
  }
}


// WEBPACK FOOTER //
// ./src/store/actions.js